export class Chistes {

  chistes = [
    '¿Por qué los pájaros no usan Facebook? Porque ya tienen Twitter.',
    '¿Qué hace una abeja en el gimnasio? ¡Zum-ba!',
    '¿Cuál es el café más peligroso del mundo? El ex-preso.',
    '¿Por qué el libro de matemáticas estaba deprimido? Porque tenía demasiados problemas.',
    '¿Qué le dice una impresora a otra? Esa hoja es tuya o es una impresión mía.',
    '¿Cómo se despiden los químicos? Ácido un placer.',
    '¿Qué le dice un semáforo a otro? No me mires que me estoy cambiando.',
    '¿Cómo se dice pelo sucio en chino? Chin cham pu.',
    '¿Cuál es el colmo de Aladdín? Tener mal genio.',
    'Si se muere una pulga, ¿a dónde va? Al pulgatorio',
    '¿Qué le dice un gusano a otro gusano? Voy a dar una vuelta a la manzana.',
    '¿Cómo se dice disparo en árabe? Ahí-va-la-bala.',
    '¿Cuál es el último animal que subió al arca de Noé? El del-fin.',
    '¿Cómo se dice pañuelo en japonés? Saka-moko.',
    '¿Qué le dice un techo a otro? Techo de menos.',
    '¿Cómo estornuda un tomate? ¡Keeeétchup!',
    '¿Cuál es la fruta más divertida? ¡La naranjajajajaja!.',
    '¿Cómo se despiden los químicos? Ácido un placer.',
    '¿Qué le dice una taza a otra? ¿Qué taza ciendo?.',
    '¿En qué se parece una bruja al fin de semana? En que los dos se van volando.',
    '¿Qué le dice un jaguar a otro jaguar? Jaguar you.',
    '¿Por qué las vacas viajan a Nueva York? Para ver muuuuusicales',
    '¿Qué hace una vaca pensando? Leche concentrada',
    '¿Cuál es el animal más antiguo? El oso panda porque está en blanco y negro',
    '¿Qué hace un piojo en la cabeza de un calvo? ¡Patinaje sobre hielo!',
    '¿Cuál es el baile favorito del tomate? ¡La salsa!',
    '¿Cuál es la fruta más explosiva? La granada',
    '¿Qué le dijo una uva verde a una uva morada? Respira, respira',
    '¿Qué le dijo el 0 al 8? Me gusta tu cinturón',
    '¿Qué le dice un cero a otro cero? No somos nada',
    '¿Cómo se dice perdido en japonés? ¿Ondetoy?',
    '¿Cómo se llama hacer dieta en chino? Kita Kilito',
    '¿Cómo se dice repollo en inglés? Rechicken',
    '¿Cómo se dice vendedor de puertas en inglés? Vende-door',
    '¿Qué le dice una pared a otra pared? Nos vemos en la esquina',
    '¿Cuál es el colmo de un ladrón? Llamarse Esteban Dido',
    '¿Está Agustín? No, estoy incomodín, la verdad',
    '¿Por qué una señora lleva pegamento al restaurante? En caso de romper la dieta',
    '¿Qué bebe el hombre invisible a la hora de almuerzo? Leche evaporada.',
    '¿Por qué fue la computadora al doctor? Porque tenía un virus.',
    '¿Qué está al final de todo? La O.',
    '¿Cuál es el colmo de un libro? Que en otoño se caigan sus hojas.',
    '¿Cuál es el colmo de un calvo? Tener ideas descabelladas.',
    '¿Cómo se llama el campeón de buceo japonés? Tokofondo.',
    '¿Por qué está contenta la escoba? Porque barriendo.',
    '¿Por qué el maestro de música necesita una escalera? Para alcanzar las notas altas.',
    '¿Por qué el televisor cruzó la carretera? Porque quería ser pantalla plana.',
    '¿Dónde cuelga Superman su supercapa? En superchero.',
    '¿Cómo se llama el campeón de escondidas? No se sabe, aún no lo han encontrado.',
    '¿Cuál es la mejor cura para la caspa? La calvicie.',
    '¿Cuál es el colmo más pequeño? El colmillo.',
    '¿Cuál es la planta que asusta? El bambú.',
    '¿Cuál es la planta que camina? La planta de los pies.',
    '¿Qué le dice un pez a otro? Nada.',
    '¿Qué pasa si una vaca se come un vidrio? La leche le sale cortada.',
    '¿Qué es un burro? ¡Un caballo que no quiso estudiar!.',
    '¿Por qué son arrugados los elefantes? Porque toma mucho tiempo plancharlos.'
  ];

}
